import React from 'react';
import styles from './style.module.css';

export default function TestimonialCardD2({ testimonial , CStyle}) {
  const { post_title, rating, post_content , testimonial_link} = testimonial

  return (
    <div className={styles.testimonialCard}>
      <div className={styles.testimonialContent}>
        <span >

        <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.230957 7.99996C0.230957 3.66496 3.77162 0.153809 8.14305 0.153809H8.67052C9.83755 0.153809 10.7804 1.08881 10.7804 2.24612C10.7804 3.40342 9.83755 4.33842 8.67052 4.33842H8.14305C6.10568 4.33842 4.45074 5.97958 4.45074 7.99996V8.52304H8.67052C10.998 8.52304 12.8903 10.3996 12.8903 12.7077V16.8923C12.8903 19.2003 10.998 21.0769 8.67052 21.0769H4.45074C2.12326 21.0769 0.230957 19.2003 0.230957 16.8923V14.8V12.7077V7.99996ZM17.1101 7.99996C17.1101 3.66496 20.6507 0.153809 25.0222 0.153809H25.5496C26.7167 0.153809 27.6595 1.08881 27.6595 2.24612C27.6595 3.40342 26.7167 4.33842 25.5496 4.33842H25.0222C22.9848 4.33842 21.3299 5.97958 21.3299 7.99996V8.52304H25.5496C27.8771 8.52304 29.7694 10.3996 29.7694 12.7077V16.8923C29.7694 19.2003 27.8771 21.0769 25.5496 21.0769H21.3299C19.0024 21.0769 17.1101 19.2003 17.1101 16.8923V14.8V12.7077V7.99996Z" fill="#004976"/>
        </svg>
        </span>
     

        <p style={CStyle.txtColor} dangerouslySetInnerHTML={{ __html: post_content }} />
      </div>
      <div className={styles.testimonialHeader}>
        
        <div className={styles.avatarContainer}>
         
        </div>
        
        <div className={styles.userInfo}>
          <p className={styles.userName} style={CStyle.titleColor}>{testimonial_link ? <a style={CStyle.titleColor} href={testimonial_link}>{post_title}</a> : post_title}</p>
        
          <div className={styles.rating}>
            {[...Array(parseInt(rating))].map((_, i) => (
              <span style={CStyle.starStyle} class="dashicons dashicons-star-filled"></span>
            ))}
            { parseInt(rating) < 5 &&  [...Array(5 - parseInt(rating))].map((_, i) => (
              <span style={CStyle.starStyle} class="dashicons dashicons-star-empty"></span>
            ))}
          </div>
        </div>
      
      </div>
      
    </div>
  )
}
